/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";
import Dropdown from "./dropdown";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const typeOption = [
  {
    value: "Tên đơn vị phụ thuộc khác tỉnh với nơi NNT đóng trụ sở chính",
    label: "Tên đơn vị phụ thuộc khác tỉnh với nơi NNT đóng trụ sở chính",
  },
  {
    value: "Tên địa điểm kinh doanh  khác tỉnh với nơi NNT đóng trụ sở chính",
    label: "Tên địa điểm kinh doanh  khác tỉnh với nơi NNT đóng trụ sở chính",
  },
  {
    value: "Nơi không có đơn vị phụ thuộc/địa điểm kinh doanh",
    label: "Nơi không có đơn vị phụ thuộc/địa điểm kinh doanh",
  },
];

const provinceOption = [
  {
    value: "An giang",
    label: "An giang",
  },
  {
    value: "Cần thơ",
    label: "Cần thơ",
  },
  {
    value: "TP Hồ Chí Minh",
    label: "TP Hồ Chí Minh",
  },
];

const districtOption = [
  {
    value: "Châu thành",
    label: "Châu thành",
  },
  {
    value: "Long xuyên",
    label: "Long xuyên",
  },
  {
    value: "Chợ mới",
    label: "Chợ mới",
  },
];

const taxAuthoritiesOption = [
  {
    value: "Cục thuế TP.HCM",
    label: "Cục thuế TP.HCM",
  },
  {
    value: "Cục thuế An giang",
    label: "Cục thuế An giang",
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    type: {
      type: "select",
      value: null,
      bg: false,
      option: typeOption,
    },
    agencyName: {
      type: "input",
      value: null,
      bg: false,
    },
    taxID: {
      type: "input",
      value: null,
      bg: false,
    },
    Province: {
      type: "select",
      value: null,
      bg: false,
      option: provinceOption,
    },
    district: {
      type: "select",
      value: null,
      bg: false,
      option: districtOption,
    },
    taxAuthoritiesProvince: {
      type: "input",
      value: null,
      bg: true,
    },
    taxAuthoritiesDistrict: {
      type: "select",
      value: null,
      bg: false,
      option: taxAuthoritiesOption,
    },
    revenue: {
      type: "input",
      value: 0,
      bg: false,
    },
    revenuePercent: {
      type: "input",
      value: 0,
      bg: true,
    },
    profitAfterTaxMustPaid: {
      type: "input",
      value: 0,
      bg: true,
    },
    remainingProfitAfterTax: {
      type: "input",
      value: 0,
      bg: false,
    },
    paddingrofitPaidAfterTax: {
      type: "input",
      value: null,
      bg: false,
    },
  },
];

export default function AppendixTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
  };

  const addNewRow = () => {
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: uuidV4(),
        bg: true,
      },
      type: {
        type: "select",
        value: null,
        bg: false,
        option: typeOption,
      },
      agencyName: {
        type: "input",
        value: null,
        bg: false,
      },
      taxID: {
        type: "input",
        value: null,
        bg: false,
      },
      Province: {
        type: "select",
        value: null,
        bg: false,
        option: provinceOption,
      },
      district: {
        type: "select",
        value: null,
        bg: false,
        option: districtOption,
      },
      taxAuthoritiesProvince: {
        type: "input",
        value: null,
        bg: true,
      },
      taxAuthoritiesDistrict: {
        type: "select",
        value: null,
        bg: false,
        option: taxAuthoritiesOption,
      },
      revenue: {
        type: "input",
        value: 0,
        bg: false,
      },
      revenuePercent: {
        type: "input",
        value: 0,
        bg: true,
      },
      profitAfterTaxMustPaid: {
        type: "input",
        value: 0,
        bg: true,
      },
      remainingProfitAfterTax: {
        type: "input",
        value: 0,
        bg: false,
      },
      paddingrofitPaidAfterTax: {
        type: "input",
        value: null,
        bg: false,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                STT
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                Loại
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                Tên đơn vị phụ thuộc địa điểm kinh doanh, tên tỉnh nơi phát sinh doanh thu bán vé
                thực tế (khách tỉnh nơi đóng trụ sở chính)
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                Mã số thuế/ Mã địa điểm kinh doanh
              </Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                Địa bàn nơi có hoạt động kinh doanh
              </Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                Cơ quan thuế quản lý địa bàn nhận phân bố
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                Doanh thu bán vé thực tế theo địa bàn
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                Tỷ lệ doanh thu bán vé thực tế theo địa bàn (%)
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                Số lợi nhuận sau thuế còn lại phải nộp cho từng tỉnh theo quyết toán
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                Số lợi nhuận sau thuế còn lại phải nộp thừa kỳ trước chuyển sang kỳ này
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                Số lợi nhuận sau thuế còn lại đã nộp cho từng tỉnh
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>Tỉnh</Th>
              <Th style={{ textAlign: "center" }}>Huyện</Th>
              <Th style={{ textAlign: "center" }}>Cơ quan thuế cấp cục</Th>
              <Th style={{ textAlign: "center" }}>Cơ quan thuế cấp chi cục</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}></Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
              <Th style={{ textAlign: "center" }}>(8)</Th>
              <Th style={{ textAlign: "center" }}>(9)</Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }} colSpan={2}>
                (11)
              </Th>
              <Th style={{ textAlign: "center" }}>(12)</Th>
              <Th style={{ textAlign: "center" }}>(13)= (12)/(15)*100%</Th>
              <Th style={{ textAlign: "center" }}>(14)= (04)*(13)</Th>
              <Th style={{ textAlign: "center" }}>(16)</Th>
              <Th style={{ textAlign: "center" }}>(16)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {index + 1}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.type.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.type.bg ? (
                      row.type.value
                    ) : row.type?.type === "select" ? (
                      <SelectTable
                        name="type"
                        id={row.id.value}
                        option={row.type.option ? row.type.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="type"
                        value={row.type.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.agencyName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.agencyName?.type !== "input" ? (
                      row.agencyName.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="agencyName"
                        value={row.agencyName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxID.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxID?.type !== "input" ? (
                      row.taxID.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="taxID"
                        value={row.taxID.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.Province.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.Province.bg ? (
                      row.Province.value
                    ) : row.Province?.type === "select" ? (
                      <SelectTable
                        name="Province"
                        id={row.id.value}
                        option={row.Province.option ? row.Province.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="Province"
                        value={row.Province.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.district.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.district.bg ? (
                      row.district.value
                    ) : row.district?.type === "select" ? (
                      <SelectTable
                        name="district"
                        id={row.id.value}
                        option={row.district.option ? row.district.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="district"
                        value={row.district.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxAuthoritiesProvince.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxAuthoritiesProvince?.type !== "input" ? (
                      row.taxAuthoritiesProvince.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="taxAuthoritiesProvince"
                        value={row.taxAuthoritiesProvince.value}
                        onChange={handleChange}
                        readOnly={true}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.taxAuthoritiesDistrict.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxAuthoritiesDistrict.bg ? (
                      row.taxAuthoritiesDistrict.value
                    ) : row.taxAuthoritiesDistrict?.type === "select" ? (
                      <SelectTable
                        name="taxAuthoritiesDistrict"
                        id={row.id.value}
                        option={
                          row.taxAuthoritiesDistrict.option
                            ? row.taxAuthoritiesDistrict.option
                            : defaultOption
                        }
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="taxAuthoritiesDistrict"
                        value={row.taxAuthoritiesDistrict.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.revenue.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenue?.type !== "input" ? (
                      row.revenue.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="revenue"
                        value={row.revenue.value}
                        onChange={handleChange}
                        readOnly={true}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.revenuePercent.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenuePercent?.type !== "input" ? (
                      row.revenuePercent.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="revenuePercent"
                        value={row.revenuePercent.value}
                        onChange={handleChange}
                        readOnly={true}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.profitAfterTaxMustPaid.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.profitAfterTaxMustPaid?.type !== "input" ? (
                      row.profitAfterTaxMustPaid.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="profitAfterTaxMustPaid"
                        value={row.profitAfterTaxMustPaid.value}
                        onChange={handleChange}
                        readOnly={true}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.remainingProfitAfterTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.remainingProfitAfterTax?.type !== "input" ? (
                      row.remainingProfitAfterTax.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="remainingProfitAfterTax"
                        value={row.remainingProfitAfterTax.value}
                        onChange={handleChange}
                        readOnly={true}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.paddingrofitPaidAfterTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.paddingrofitPaidAfterTax?.type !== "input" ? (
                      row.paddingrofitPaidAfterTax.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="paddingrofitPaidAfterTax"
                        value={row.paddingrofitPaidAfterTax.value}
                        onChange={handleChange}
                        readOnly={true}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colspan="7"
                row={{ bold: true }}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng:
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                [19]
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
            <tr>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                1
              </Td>
              <Td
                colspan="7"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
            <tr>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colspan="7"
                row={{ bold: true }}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                Cộng các tỉnh
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                [20]
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
            <tr>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colspan="7"
                row={{ bold: true }}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                }}
              >
                Tỉnh... nơi đóng trụ sở chính
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                0
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
